import parsePhoneNumber from "libphonenumber-js"

import { Phone } from "@/modules/sign-up/api/types"

export default function formatPhone(phone?: Phone) {
  if (!phone) {
    return null
  }

  const phoneNumber = parsePhoneNumber(phone.number, {
    defaultCallingCode: phone.countryCode.replace("+", ""),
  })

  return phoneNumber?.formatInternational() ?? phone.number
}
